<template lang="pug" id="rich_text">
extends ./BaseMessage/BaseMessage.pug
block child
  .message-wrapper(:class="classNames.messageWithLocation"
                    :style="{textAlign: textAlign}")
    .rich-text__content(v-if="inWebchat")
      avatar( :inWebchat="inWebchat",
              :senderType="senderType",
              :avatarPhoto="avatar",
              :senderInitials="senderInitials"
              :avatarAltText="avatarAltText")
      .agent-message-webchat-container
        .message-bubble_header
          .message-bubble_date
            aiq-timeago(:since="messageDate" :maxTime="maxTime")
        .message-webchat_content(v-if="content"
                                v-html="content"
                                @click="onLink"
                                :class="{'message-customer': message.sender_type === 'customers',\
                                'message-agent': message.sender_type === 'agents' }")
        .message-attachments.message-item
          rich-text-message-attachments(:attachments="attachments"
            :inWebchat="inWebchat"
            @link="$emit('link', $event)"
            :senderType="senderType"
            :imgAltText="imgAltText")
    .message-container(v-else
                      :class="classNames.message")
      .message-item(v-if="senderType")
        avatar( :inWebchat="inWebchat",
              :senderType="senderType",
              :avatarPhoto="avatar",
              :senderInitials="senderInitials"
              :avatarAltText="avatarAltText")
        aiq-dropdown(:placement="messageMenuPlacement"
                    :show-timeout="messageMenuShowTimeout"
                    class="mt-4"
                    popper-class="menu-message-popper"
                    @visible-change="handleVisibleChange")
          .message-bubble
            .message-bubble_header
              .message-bubble_name
                i(v-if="senderType === 'customers'",
                  :title="channelInfo.title",
                  :class="`aiq-ico-conversation-${channel}`")
                span(v-if="senderType === 'agents'") {{ senderName }}
              .message-bubble_date
                aiq-timeago(:since="messageDate" :maxTime="maxTime")
            .message-bubble_content(v-html="content" @click="onLink")
            .message-attachments(:class="classNames.attachments")
              rich-text-message-attachments(:attachments="attachments"
                :inWebchat="inWebchat"
                :senderType="senderType"
                @link="$emit('link', $event)"
                :imgAltText="imgAltText")
            slot(v-if="senderType === 'customers'", name="message-cue")
          template(v-slot:dropdown)
            aiq-dropdown-menu.message-menu
              slot(name="message-buttons")
          slot(name="message-cue")
</template>

<script>
import get from 'lodash/get';

import { url } from '../../../lib/formatters';
import BaseMessage from './BaseMessage/BaseMessage.vue';
import Avatar from '../../Avatar.vue';
import RichTextMessageAttachments from './RichTextMessageAttachments.vue';

const MESSAGE_MENU_SHOW_TIMEOUT = 250;
/*
  Workaround to disable the menu when no items
  this eleme.io version do not support dropdown disabling
*/
const MESSAGE_MENU_SHOW_TIMEOUT_DISABLED = 50000;

export default {
  extends: BaseMessage,
  components: {
    Avatar,
    RichTextMessageAttachments,
  },
  name: 'richTextMessage',
  props: {
    inWebchat: Boolean,
  },
  computed: {
    classNames() {
      const message = {
        'message-customer': this.senderType === 'customers',
        'message-agent': this.senderType === 'agents',
      };

      return {
        attachments: {
          'message-attachment-customer': this.senderType === 'customers',
          'message-attachment-agent': this.senderType === 'agents',
        },
        message,
        messageWithLocation: {
          'message-customer': message['message-customer'],
          'message-agent': message['message-agent'],
          'message-webchat': this.inWebchat,
        },
      };
    },
    attachments() {
      return get(this.message, 'payload.rich_text.attachments', []);
    },
    attachmentType() {
      return get(
        this.message,
        'payload.rich_text.attachments[0].message_type',
        '',
      );
    },
    hasMenuItems() {
      const messageButtons = this.$slots['message-buttons']();
      return Array.isArray(messageButtons) && messageButtons.some(x => x.key);
    },
    messageMenuShowTimeout() {
      return this.hasMenuItems ? MESSAGE_MENU_SHOW_TIMEOUT : MESSAGE_MENU_SHOW_TIMEOUT_DISABLED;
    },
    messageMenuPlacement() {
      return this.senderType === 'agents' ? 'top-start' : 'top-end';
    },
  },
  methods: {
    onLink(e) {
      if (e.target.id === 'aiq-link') {
        this.$emit('link', {
          type: 'url',
          url: url(e.target.innerHTML),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rich-text__content {
  display: flex;
  max-width: 336px;
}
.message-webchat .message-attachments {
  max-width: 13.5rem;
}
.message-customer .agent-message-webchat-container{
  justify-content: flex-end;
}
.mt-4 {
  margin-top: 4px;
}
</style>
